const { lazy } = require('react')

const DiagnosticList = lazy(() => import('./DiagnosticList'))

export { DiagnosticList }
